<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>
            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>

                <template #cell(flow)="{ value }">
                    <span>{{ getFlowName(value) }}</span>
                </template>

                <template #cell(entity)="{ value }">
                    <span>{{ getEntityName(value) }}</span>
                </template>

                <template #cell(reference_entity)="{ value }">
                    <span>{{ getEntityName(value) }}</span>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['items', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                'entity',
                'flow',
                { key: 'reference_entity', label: 'Reference' },
            ],
        }
    },

    mounted() {},

    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        flowOptions() {
            return this.$store.getters['transactionType/flowOptions']
        },

        entityOptions() {
            return this.$store.getters['transactionType/entityOptions']
        },
    },

    methods: {
        getEntityName(value) {
            if (value == -1) return 'None'
            return (this.entityOptions.find(x => x.value === value) || {}).text
        },

        getFlowName(value) {
            return (this.flowOptions.find(x => x.value === value) || {}).text
        },
    },
}
</script>
<style></style>
